import { makeAutoObservable, runInAction } from 'mobx';
import { aiCopilotServer } from '@/service/ai-copilot';

export interface IAiSession {
  sessionId: string;
  title?: string;
  createTime?: number;
  updateTime?: number;
}

export interface IAiMessage {
  queryId: string;
  sessionId: string;
  query: string;
  answer: string;
  createTime?: number;
  rating?: number;
}

export interface IAiAnalysis {
  feature?: string;
  clientIdentify?: string;
  productId?: string;
  content?: string;
  qaType?: number;
  createTime?: number;
}

export class AiStore {
  latestAnalysis = '';

  analysisType: any;

  latestAnalysisLoaded = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  /**
   * 获取分析摘要
   */
  async getAnalysisSummary(
    feature: string,
    clientIdentify: string,
    productId: string,
  ) {
    if (this.latestAnalysisLoaded) return;

    const latestAnalysis = await aiCopilotServer.getLatestAnalysis({
      feature,
      clientIdentify,
      productId,
    });

    runInAction(() => {
      this.latestAnalysis = latestAnalysis?.content ?? '';
      this.analysisType = latestAnalysis?.qaType;
      this.latestAnalysisLoaded = true;
    });
  }
}
